import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Output,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { ButtonComponent } from '@shared/components/button/button.component';
import { MessagesConstants } from '@shared/constants/messages.constants';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { OverlayService } from '@shared/services/overlay.service';
import { injectPermissions } from '@shared/store/auth/auth.service';
import { InvoiceModel } from '@shared/store/invoice/invoice.model';

import { UploadDocumentsDialogComponent } from '../../upload-documents-dialog/upload-documents-dialog.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, ButtonComponent],
  selector: 'aux-invoice-items-no-rows',
  template: `
    <div class="flex h-[150px] items-center justify-center">
      <span>No rows to show. &nbsp;</span>
      <aux-button
        [auxTooltip]="disabledTooltip()"
        [disabled]="disabled()"
        (click)="upload()"
        variant="hyperlink"
        label="Upload"
        classList="p-0 leading-normal"
      />
      <span>&nbsp;&nbsp;PDF and designate as Invoice for Auxilius line item parsing.</span>
    </div>
  `,
})
export class InvoiceItemsNoRowsComponent {
  overlayService = inject(OverlayService);

  permissions = injectPermissions({
    hasEditInvoice: 'PERMISSION_UPDATE_INVOICES',
  });

  disabled = computed(() => !this.permissions().hasEditInvoice);
  disabledTooltip = computed(() => {
    if (!this.permissions().hasEditInvoice) {
      return MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION;
    }

    return '';
  });

  invoice = input.required<InvoiceModel>();

  @Output() closeDialog = new EventEmitter();

  async upload() {
    await firstValueFrom(
      this.overlayService.openPopup<
        { invoice: InvoiceModel },
        unknown[],
        UploadDocumentsDialogComponent
      >({
        content: UploadDocumentsDialogComponent,
        data: { invoice: this.invoice() },
        settings: {
          header: 'Upload Document for Invoice',
          primaryButton: {
            action: async (instance) => {
              await instance?.onSave();
            },
            disabled: (instance) => !instance?.hasChanges,
            pendoTag: 'invoice-items-upload-pdf-save-button',
          },
        },
      }).afterClosed$
    );

    this.closeDialog.emit();
  }
}
